import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { Outlet } from 'react-router';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { PartnerActiveLocationProvider } from './activeLocationContext';

const PartnerScannerView = lazy(() => import('./PartnerScannerView'));
const PartnerEquipmentListView = lazy(() => import('./PartnerEquipmentListView'));
const PartnerGetTheAppView = lazy(() => import('./get-the-app/PartnerGetTheAppView'));

function PartnerOutlet() {
	return (
		<PartnerActiveLocationProvider>
			<Outlet />
		</PartnerActiveLocationProvider>
	);
}

/**
 * Partner Portal Routes
 *
 * Routes for partner (external company) users:
 * - /partner/scan - Equipment scanner view (default)
 * - /partner/equipment - Equipment list view
 *
 * The wrapping <PartnerActiveLocationProvider> persists the user's chosen
 * location across navigation between Scanner and Equipment within this segment.
 */
const partnerRoutes: FuseRouteItemType[] = [
	{
		path: 'partner',
		auth: ['Partner', 'PartnerAdmin'],
		element: <PartnerOutlet />,
		children: [
			{ index: true, element: <LegacyRouteRedirect to="/partner/scan" /> },
			{
				path: 'scan',
				element: <PartnerScannerView />
			},
			{
				path: 'equipment',
				element: <PartnerEquipmentListView />
			},
			{
				path: 'get-the-app',
				element: <PartnerGetTheAppView />
			}
		]
	}
];

export default partnerRoutes;
